import React from "react";
import Card from "components/card";

interface BasicInfoProps {
  patientName: string;
  questionnaireName: string;
  completedAt: string;
  scoringType: string;
  questionnaireDescription?: string;
}

const BasicInfo: React.FC<BasicInfoProps> = ({
  patientName,
  questionnaireName,
  completedAt,
  scoringType,
  questionnaireDescription,
}) => {
  const completedDate = new Date(completedAt).toLocaleString();

  return (
    <Card extra="w-full p-4 md:p-6">
      <h2 className="mb-4 border-b border-gray-200 pb-2 text-xl font-bold text-navy-700 dark:text-white">
        Información
      </h2>
      <div className="space-y-3">
        <div>
          <p className="text-sm font-medium text-gray-500">Paciente</p>
          <p className="text-lg font-medium text-navy-700 dark:text-white">{patientName}</p>
        </div>
        <div>
          <p className="text-sm font-medium text-gray-500">Cuestionario</p>
          <p className="text-lg font-medium text-navy-700 dark:text-white">{questionnaireName}</p>
        </div>
        {questionnaireDescription && (
          <div>
            <p className="text-sm font-medium text-gray-500">Descripción</p>
            <p className="text-gray-700 dark:text-gray-400">{questionnaireDescription}</p>
          </div>
        )}
        <div>
          <p className="text-sm font-medium text-gray-500">Fecha de Completado</p>
          <p className="text-lg font-medium text-navy-700 dark:text-white">{completedDate}</p>
        </div>
        <div>
          <p className="text-sm font-medium text-gray-500">Método de Puntuación</p>
          <p className="text-lg font-medium text-navy-700 dark:text-white">{scoringType}</p>
        </div>
      </div>
    </Card>
  );
};

export default BasicInfo; 